export default {
      id: "driller-usage",
      viewBox: "0 0 125.63 188.44",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#driller",
      toString: function () {
        return this.url;
      }
    }